import React, { FC, useState } from "react";
import { Button, Table } from "reactstrap";
import { useMediaQuery } from "react-responsive";

// styles
import styles from "./DataTable.module.scss";

// icons

//component

//interface

//api
import { setupProvisionRequestModel } from "../../../api/apiRequestObjects";
import apis from "../../../api/apis";

//config
import GLOBAL_MEDIA_QUERIES from "../../../config/globalMediaQueries";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import {
  notifyServerError,
  notifySuccessfulProvison,
} from "../../../config/toastNotification";
import { IPartnerStore } from "../../../interfaces/store";
import { ILocation } from "../../../interfaces/user";
import SelectCombo from "./components/SelectCombo";
import { SelectChangeEvent } from "@mui/material/Select";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

interface IProps {
  partnerStoreList: IPartnerStore[];
  userLocationList?: ILocation[];
}

//manual close button for toast notifications
const CloseButton = ({ closeToast }: any) => (
  <i
    className="material-icons"
    onClick={closeToast && window.location.reload()}
  ></i>
);

const initialStore: IPartnerStore = {
  PartnerStoreId: "",
  PartnerStoreName: "",
  PartnerStoreCode: "",
  UserLocationInOurSystem: null,
  ContactEmails: [],
  AveragePreparationTime: 0,
  IsProvisionEnabled: false,
};

const DataTable: FC<IProps> = ({
  partnerStoreList,
  userLocationList,
}): JSX.Element => {
  const isTablet = useMediaQuery({ query: GLOBAL_MEDIA_QUERIES.tab });

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  setupProvisionRequestModel.UID.UserKey = user.UserKey;
  setupProvisionRequestModel.UID.LocationKey = user.LocationKey;
  setupProvisionRequestModel.UID.CompanyKey = user.CompanyKey;
  setupProvisionRequestModel.UID.EnvironmentName = user.EnvironmentName;

  const [openSnack, setOpenSnack] = useState(false);
  const [selectedLocationKey, setSelectedLocationKey] = React.useState(0);
  const [selectedStore, setSelectedStore] =
    React.useState<IPartnerStore>(initialStore);

  /*   const handleSnackClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  }; */

  const handleComboChange = (event: SelectChangeEvent) => {
    setSelectedLocationKey(parseInt(event.target.value));
  };

  const selectStore = (partnerStore: IPartnerStore) => {
    setSelectedStore(partnerStore);
  };

  const handleProvisionOff = async (partnerStore: IPartnerStore) => {
    setupProvisionRequestModel.PartnerStore = partnerStore;
    setupProvisionRequestModel.PartnerStore.IsProvisionEnabled = false;

    //console.log(partnerStore);
    /*     setupProvisionRequestModel.PartnerStore.UserLocationInOurSystem =
      userLocationList?.filter(
        (x) => x.LocationId === selectedLocationKey
      )[0] ?? null; */

    const response = await apis.Provisions.provisionEnableDisble(
      setupProvisionRequestModel
    );

    if (response.ResponseType === APIResponseType.Success) {
      //setOpenSnack(true);
      notifySuccessfulProvison();
      //window.location.reload();
    } else {
      notifyServerError();
    }
  };

  const handleProvisionOn = async () => {
    setupProvisionRequestModel.PartnerStore = selectedStore;
    setupProvisionRequestModel.PartnerStore.UserLocationInOurSystem =
      userLocationList?.filter(
        (x) => x.LocationId === selectedLocationKey
      )[0] ?? null;
    setupProvisionRequestModel.PartnerStore.IsProvisionEnabled = true;

    const response = await apis.Provisions.provisionEnableDisble(
      setupProvisionRequestModel
    );

    //console.log();
    if (response.ResponseType === APIResponseType.Success) {
      setOpenSnack(true);
      window.location.reload();
    } else {
      //notifyServerError();
    }
  };

  return (
    <div>
      <Table size="sm" hover>
        <thead>
          <tr id={styles.table_head}>
            <th className="text-center">Store ID</th>
            <th className="text-center">Partner Store Name</th>
            <th className="text-center">Location</th>
            <th className="text-center">Is Provisioned</th>
            <th className="text-center">Provision On/Off</th>
          </tr>
        </thead>
        <tbody>
          {partnerStoreList &&
            partnerStoreList.map((partnerStore: IPartnerStore) => (
              <tr key={partnerStore.PartnerStoreId}>
                <td className={styles.store_id}>
                  {partnerStore.PartnerStoreCode}
                </td>
                <td className={styles.address}>
                  {partnerStore.PartnerStoreName}
                </td>
                <td
                  key={partnerStore.PartnerStoreId}
                  className={styles.city}
                  onClick={() => selectStore(partnerStore)}
                >
                  {partnerStore.IsProvisionEnabled &&
                  partnerStore?.UserLocationInOurSystem?.LocationName !==
                    null ? (
                    partnerStore?.UserLocationInOurSystem?.LocationName
                  ) : (
                    <SelectCombo
                      userLocationList={userLocationList}
                      selectedLocationKey={selectedLocationKey}
                      handleComboChange={handleComboChange}
                      partnerStoreId={partnerStore.PartnerStoreId}
                      selectedStore={selectedStore}
                    />
                  )}
                </td>
                <td className={styles.city}>
                  {partnerStore.IsProvisionEnabled ? (
                    <p style={{ color: "green" }}>Yes</p>
                  ) : (
                    <p style={{ color: "red" }}>No</p>
                  )}
                </td>
                <td className={styles.provision_actions}>
                  {partnerStore.IsProvisionEnabled ? (
                    <Button onClick={() => handleProvisionOff(partnerStore)}>
                      Off
                    </Button>
                  ) : (
                    <Button
                      onClick={handleProvisionOn}
                      disabled={
                        selectedLocationKey > 1 &&
                        partnerStore.PartnerStoreId ===
                          selectedStore.PartnerStoreId
                          ? false
                          : true
                      }
                    >
                      On
                    </Button>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      <ToastContainer
        className={styles.toast_notifier}
        closeButton={CloseButton}
      />
      {/*       <Snackbar
        open={openSnack}
        autoHideDuration={6000}
        onClose={handleSnackClose}
        key={"top" + "center"}
      >
        <Alert
          onClose={handleSnackClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Provision State Update Successfully
        </Alert>
      </Snackbar> */}
    </div>
  );
};

export default DataTable;
